import clsx from 'clsx';

type ArrowDownIconProps = {
  isOpen?: boolean;
};

export const ArrowDownIcon = ({ isOpen }: ArrowDownIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('transition-transform duration-200', isOpen && 'rotate-180')}
    >
      <path d="M6 9l6 6 6-6" stroke="#4B5563" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
